import {getLocator} from '../../../rest/locators'
import type {Branch} from '../../../services/rest'
import type {BuildTypeId} from '../../../types'
import {getProjectBuildTypeFilter} from '../../../types'

import {BuildState} from './BuildStateFilter.consts'

export const BUILD_STATE_COUNT_LOOKUP_LIMIT = 50000

// The counter shows the exact value up to this limit; above it (or when the
// backend reports more) a trailing "+" is appended. Fetching one extra build
// (DISPLAY_LIMIT + 1) lets us detect ">limit" from the returned value alone.
export const BUILD_STATE_COUNT_DISPLAY_LIMIT = 100

export type CountState =
  | BuildState.QUEUED
  | BuildState.RUNNING
  | BuildState.SUCCESSFUL
  | BuildState.FAILED
  | BuildState.FAILED_TO_START
  | BuildState.CANCELED

export const COUNT_STATES: readonly CountState[] = [
  BuildState.QUEUED,
  BuildState.RUNNING,
  BuildState.SUCCESSFUL,
  BuildState.FAILED,
  BuildState.FAILED_TO_START,
  BuildState.CANCELED,
]

export type BuildStateCountFilters = {
  buildTypeId: BuildTypeId
  branch?: Branch | null
  tag?: ReadonlyArray<string>
  pinned?: boolean
  starred?: boolean
  agentPattern?: string | null
}

export const buildStateCountLocator = (
  filters: BuildStateCountFilters,
  state: CountState,
): string =>
  getLocator({
    projectBuildtype: getProjectBuildTypeFilter({buildTypeId: filters.buildTypeId}),
    branch: filters.branch ?? undefined,
    tag: filters.tag != null && filters.tag.length > 0 ? [...filters.tag] : undefined,
    buildState: [state],
    pinned: filters.pinned,
    starred: filters.starred,
    agentPattern: filters.agentPattern ?? undefined,
  })
